import { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Icon, IconButton, Tooltip, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { DataGrid } from '@material-ui/data-grid';

import Loader from '../../common/loader';

import AuthContext from '../../context';
import helpers from '../../utils/helpers';
import { get } from '../../utils/api-services';
import themeColors from '../../assets/colors';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    controls: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 20
    },
    create: {
        marginLeft: 20,
        ...themeColors.greenBtn
    },
    tableContainer: {
        width: '100%'
    }
}));

const GroupIndex = ({ permissions }) => {

    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const classes = useStyles();
    const [state, setState] = useState({
        loading: true,
        data: [],
        permissions: {}
    });

    useEffect(() => {
        setState(prev => ({ ...prev, permissions }));
    }, [permissions]);

    useEffect(() => {
        window.document.title = 'User groups | IAM';

        makeRequest();
    }, []);

    const makeRequest = async () => {
        showLoader(true);
        const response = await get('/iamGroup/index');
        if (response.status === 200) {
            setState(prev => ({
                ...prev,
                loading: false,
                data: response?.data ?? [],
            }));
        } else {
            console.log('[GroupIndex] makeRequest error', response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    const getUsers = ({ value }) => value?.length ?? '0';
    const getPermissions = ({ value }) => value?.length ? '✓ Defined' : '✗ Not defined';

    const renderCell = ({ row }) => {
        return (
            <Link to={`/iam/groups/detail/${row.idiam_group}`} target='_blank'>
                <Tooltip title='Show detail' placement='top'>
                    <IconButton>
                        <Icon>{'visibility'}</Icon>
                    </IconButton>
                </Tooltip>
            </Link>
        );
    }

    const columns = [
        { field: 'name', headerName: 'Name', flex: 1, minWidth: 200 },
        { field: 'description', headerName: 'Description', flex: 1.5, minWidth: 300 },
        { field: 'users', headerName: 'Users', flex: 0.5, minWidth: 100, valueGetter: getUsers },
        { field: 'policies', headerName: 'Permissions', flex: 1, minWidth: 200, valueGetter: getPermissions },
        { field: 'actions', headerName: 'Actions', flex: 0.5, minWidth: 100, renderCell }
    ];

    if (state.loading) return <Loader />;

    return (
        <div className={classes.root}>
            <div className={classes.controls}>
                <Button
                    variant='contained'
                    className={classes.create}
                    component={Link}
                    to={'/iam/groups/create'}
                >
                    {'Create group'}
                </Button>
            </div>

            <div className={classes.tableContainer}>
                <DataGrid
                    rows={state.data}
                    columns={columns}
                    pageSize={45}
                    density='compact'
                    autoHeight
                    getRowId={row => row.idiam_group}
                />
            </div>
        </div>
    );
}

export default GroupIndex;